export default __webpack_public_path__ + "static/media/general_insights_full.fb32fbfa.svg";